import {useEmailContext} from '../../../../../context';
import {useEffectOnce} from 'usehooks-ts';
import {TVoidFunction} from '../../../../../types';

export const useUpdateActiveHyperlink: TVoidFunction = () => {
    const {
        handlers: {updateActiveHyperlink}
    } = useEmailContext();

    useEffectOnce(() => {
        updateActiveHyperlink(true);

        return () => {
            updateActiveHyperlink(false);
        };
    });
};
